import { useMutation, useQueryClient } from "@tanstack/react-query";
import { syncHomeSectionItems } from "../../api/apiHomeSections";
import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";

export const useSyncHomeSectionItems = () => {
    const queryClient = useQueryClient();
    const { t } = useTranslation();

    const { mutate: syncItemsMutate, isPending: isSyncing } = useMutation({
        mutationFn: ({ id, items }) => syncHomeSectionItems(id, items),
        onSuccess: (res) => {
            toast.success(res.message);
            queryClient.invalidateQueries({ queryKey: ["home-sections"] });
            queryClient.invalidateQueries({ queryKey: ["home-section"] });
        },
        onError: (error) => {
            console.error("Error syncing items:", error);
            toast.error(error.response?.data?.message || t("Error syncing items"));
        },
    });

    return { syncItemsMutate, isSyncing };
};
